import { render } from "./OnlineTestView.vue?vue&type=template&id=47b46358"
import script from "./OnlineTestView.vue?vue&type=script&lang=js"
export * from "./OnlineTestView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__